module.exports = __webpack_public_path__ + "img/basedata_blue.f3e89648.svg";